import URLConfig from '@Config/urls/url.config';
import * as DebitModulePages from '@Modules/cardManagementSystem/debit/pages';
import { Route } from 'react-router-dom';

const debitHolderRoutes: any[] = [
  // Global Settings menu routes
  <Route
    path={URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.GLOBAL_SETTINGS_MENU.ROOT}
    element={<DebitModulePages.DebitLayout />}
  >
    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.GLOBAL_SETTINGS_MENU
          .PERIODIC_MISCELLANEOUS_FEES
      }
      element={<DebitModulePages.PeriodicMiscellaneousFeesPage />}
    />
    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.GLOBAL_SETTINGS_MENU
          .ACCOUNT_STATUS_REASON
      }
      element={<DebitModulePages.AccountStatusReasonPage />}
    />
  </Route>,

  //   Holder Management menu routes
  <Route
    path={URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.HOLDER_MANAGEMENT_MENU.ROOT}
    element={<DebitModulePages.DebitLayout />}
  >
    <Route
      path={URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.HOLDER_MANAGEMENT_MENU.DEBIT_APPLICATION_MENU.ROOT}
      element={<DebitModulePages.DebitLayout />}
    >
      <Route
        path={
          URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.HOLDER_MANAGEMENT_MENU
            .DEBIT_APPLICATION_MENU.DEBIT_APPLICATION
        }
        element={<DebitModulePages.DebitApplicationPage />}
      />
      <Route
        path={
          URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.HOLDER_MANAGEMENT_MENU
          .DEBIT_APPLICATION_MENU.DEBIT_APPLICATION_CONSULTATION
        }
        element={<DebitModulePages.DebitApplicationConsultationPage />}
      />
    </Route>

    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.HOLDER_MANAGEMENT_MENU
          .DEBIT_APPLICATION_VALIDATION
      }
      element={<DebitModulePages.DebitApplicationValidationPage />}
    />
  </Route>,

  // Debit Operations menu routes
  <Route
    path={URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.DEBIT_OPERATIONS_MENU.ROOT}
    element={<DebitModulePages.DebitLayout />}
  >
    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.DEBIT_OPERATIONS_MENU
          .ADD_NEW_ACCOUNT
      }
      element={<DebitModulePages.AddNewPage />}
    />
    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.DEBIT_OPERATIONS_MENU
          .CARD_ACCOUNT_LINK
      }
      element={<DebitModulePages.CardAccountLinkPage />}
    />
    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.DEBIT_OPERATIONS_MENU
          .TRNFR_CARD_ACCOUNT_LINK
      }
      element={<DebitModulePages.TrnfrCardAccountLinkPage />}
    />
    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.DEBIT_OPERATIONS_MENU
          .ACCOUNT_LIST
      }
      element={<DebitModulePages.AccountListPage />}
    />
    <Route
      path={
        URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.DEBIT_OPERATIONS_MENU
          .TRANSFER_ACCOUNT_LIST
      }
      element={<DebitModulePages.TransferAccountListPage />}
    />
  </Route>,
];

export default debitHolderRoutes;
